import { gsap } from 'gsap'
// import $ from 'jquery'
import { ScrollTrigger } from 'gsap/ScrollTrigger.js'

gsap.registerPlugin(ScrollTrigger)

export default {
  init() {
    // JavaScript to be fired on the home page
    this.eyeModal()
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
    this.homeBackgroundAnim()
    // setTimeout(this.homeBackgroundAnim, 10000)
  },
  eyeModal() {
    const modal = document.getElementById('eyeCatcher')
    const modalClose = document.getElementsByClassName('eye-catcher-close')[0]
    if (modal) {
      modalClose.onclick = function () {
        modal.style.display = 'none'
      }
    }
  },

  homeBackgroundAnim() {
    // const page = document.querySelector('.home')
    const page = document.querySelector('.home-animation-wrapper')
    let bubblesBack = document.querySelector('#home-bubbles-back')
    let referenceGroup = document.querySelector('.reference-group')
    let visibleGroup = document.querySelector('.visible-group')
    let referenceBubbles = Array.from(referenceGroup.querySelectorAll('circle'))
    referenceBubbles = referenceBubbles.map(el => {
      return { el: el, r: el.getAttribute('r'), anim: false }
    })
    referenceBubbles.sort((a, b) => {
      return +a.el.getAttribute('cy') - +b.el.getAttribute('cy')
    })
    const bubblesBackDefaultViewbox = {
      w: 888,
      h: 5182,
    }

    let scrollTimeline

    let bubblesToAnimate = setupLayout()
    setupScrollAnimation(bubblesToAnimate)
    setupBurstAnimation(bubblesToAnimate)

    const handleResize = () => {
      gsap.killTweensOf(bubblesToAnimate)
      if (scrollTimeline.scrollTrigger) {
        scrollTimeline.scrollTrigger.kill(true)
      }
      if (scrollTimeline) {
        scrollTimeline.kill(true)
      }
      bubblesToAnimate = setupLayout()
      setupScrollAnimation(bubblesToAnimate)
      setupBurstAnimation(bubblesToAnimate)
    }

    window.addEventListener('resize', handleResize)

    new MutationObserver(() => {
      // console.log('redraw bubble anim') //eslint-disable-line
      handleResize()
    }).observe(document.body, { attributes: true, childList: true }) //eslint-disable-line

    // make SVG visible only when it's all set up
    gsap.set(bubblesBack, {
      opacity: 1,
    })

    function setupLayout() {
      bubblesBack.setAttribute(
        'viewBox',
        '0 0 ' + bubblesBackDefaultViewbox.w + ' ' + bubblesBackDefaultViewbox.h
      )
      const initBubblesHeight = bubblesBack.getBoundingClientRect().height
      const ratio = page.clientHeight / initBubblesHeight
      const newHeight = bubblesBackDefaultViewbox.h * ratio
      bubblesBack.setAttribute(
        'viewBox',
        '0 0 ' + bubblesBackDefaultViewbox.w + ' ' + newHeight
      )

      visibleGroup.innerHTML = ''
      let bubblesFiltered = []

      let newGroup, newBubble
      if (ratio < 1) {
        // original SVG is smaller than page height => crop the bottom bubbles
        newGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g')
        visibleGroup.appendChild(newGroup)
        referenceBubbles.forEach(b => {
          if (+b.el.getAttribute('cy') < newHeight) {
            newBubble = b.el.cloneNode(true)
            newGroup.appendChild(newBubble)
            bubblesFiltered.push({ el: newBubble, r: b.r, anim: false })
          }
        })
      } else {
        // original SVG is bigger than page height => repeat the bubbles
        const ratioFloored = Math.floor(ratio)
        for (let i = 0; i < ratioFloored; i++) {
          newGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g')
          visibleGroup.appendChild(newGroup)
          gsap.set(newGroup, {
            y: bubblesBackDefaultViewbox.h * i,
          })
          referenceBubbles.forEach(b => {
            newBubble = b.el.cloneNode(true)
            newGroup.appendChild(newBubble)
            bubblesFiltered.push({ el: newBubble, r: b.r, anim: false })
          })
        }

        // add the last cropped group
        const extraHeight =
          newHeight - bubblesBackDefaultViewbox.h * ratioFloored
        newGroup = document.createElementNS('http://www.w3.org/2000/svg', 'g')
        visibleGroup.appendChild(newGroup)
        gsap.set(newGroup, {
          y: bubblesBackDefaultViewbox.h * ratioFloored,
        })
        referenceBubbles.forEach(b => {
          if (+b.el.getAttribute('cy') < extraHeight) {
            newBubble = b.el.cloneNode(true)
            newGroup.appendChild(newBubble)
            bubblesFiltered.push({ el: newBubble, r: b.r, anim: false })
          }
        })
      }

      return bubblesFiltered
    }

    function setupScrollAnimation(bubblesToAnimate) {
      scrollTimeline = gsap.timeline({
        scrollTrigger: {
          trigger: bubblesBack,
          start: '0%+=' + window.innerHeight * 0.5 + ' 50%',
          end: '100%-=' + window.innerHeight * 0.5 + ' 50%',
          scrub: true,
        },
      })
      bubblesToAnimate.forEach((b, bIdx) => {
        const timeWeight = bIdx / bubblesToAnimate.length - 0.5
        let startTime = bIdx / bubblesToAnimate.length
        startTime += timeWeight * 0.1
        startTime += 0.08 * (Math.random() - 0.5)
        if (startTime < 0) {
          startTime = Math.random() * -startTime
        } else if (startTime > 0.99) {
          startTime = 0.99 - Math.random() * 2 * (startTime - 0.99)
        }
        scrollTimeline.fromTo(
          b.el,
          {
            attr: { r: 0 },
          },
          {
            duration: 0.01,
            attr: { r: b.r },
            ease: 'back(2).out',
          },
          startTime
        )
      })
    }

    function setupBurstAnimation(bubblesToAnimate) {
      gsap.ticker.remove(burstRandomBubble)
      gsap.ticker.add(burstRandomBubble)

      const frequency = 0.85 // set it 0 to 1

      function burstRandomBubble() {
        if (Math.random() > frequency) {
          let randomBubble = null
          let bubbleToCheck = null
          let cnt = 30
          do {
            cnt--
            bubbleToCheck =
              bubblesToAnimate[
                Math.floor(Math.random() * bubblesToAnimate.length)
              ]
            if (
              isInViewport(bubbleToCheck.el) &&
              +bubbleToCheck.el.getAttribute('r') > 0 &&
              !bubbleToCheck.anim
            ) {
              randomBubble = bubbleToCheck
              gsap
                .timeline({
                  onStart: () => (randomBubble.anim = true),
                  onComplete: () => (randomBubble.anim = false),
                })
                .fromTo(
                  randomBubble.el,
                  {
                    attr: { r: randomBubble.r },
                  },
                  {
                    duration: 0.12,
                    attr: { r: Math.max(randomBubble.r * 1.15, 6) },
                  },
                  0.6
                )
                .set(randomBubble.el, {
                  attr: { r: 0 },
                })
                .to(
                  randomBubble.el,
                  {
                    duration: 0.2 * randomBubble.r,
                    attr: { r: randomBubble.r },
                    ease: 'back(1.2).out',
                  },
                  1.3 + Math.random()
                )
            }
          } while (randomBubble === null && cnt)
        }
      }

      function isInViewport(element) {
        const rect = element.getBoundingClientRect()
        return (
          rect.top >= 0 &&
          rect.bottom <=
            (window.innerHeight || document.documentElement.clientHeight)
        )
      }
    }
  },
}
